module.exports = __webpack_public_path__ + "img/label-youtube-thumbnail.99eb4d16.jpeg";